import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBolt, FaChartLine, FaSearch, FaThermometerHalf, FaTint } from 'react-icons/fa';
import { getTerminalSummaries } from '../services/api';
import { getTerminalName } from '../utils/terminalNames';

const GraphsOverviewPage = ({ token }) => {
  const navigate = useNavigate();
  const [terminals, setTerminals] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const load = async () => {
      const res = await getTerminalSummaries(token, 7);
      if (res.cod === 200) setTerminals(res.data || []);
    };
    load();
  }, [token]);

  const query = search.toLowerCase();
  const filtered = terminals.filter((t) => {
    const friendlyName = getTerminalName({ guid: t.guid, descripcion: t.terminal?.descripcion }).toLowerCase();
    return !query
      || t.guid?.toLowerCase().includes(query)
      || friendlyName.includes(query)
      || t.terminal?.ubicacion?.toLowerCase().includes(query);
  });

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Gráficos</h1>
        <p className="text-sm text-gray-500 mt-1">Selecciona una terminal para ver tendencia de 7 días</p>
      </div>

      <div className="relative mb-4">
        <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none"
          placeholder="Buscar por nombre, GUID o ubicación..."
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {filtered.map((t) => (
          <button
            key={t.guid}
            onClick={() => navigate(`/graficos/${t.guid}`)}
            className="text-left bg-white rounded-xl border border-gray-200 p-4 shadow-sm hover:shadow-md transition-all"
          >
            <div className="flex items-center justify-between mb-3">
              <p className="text-sm font-semibold text-gray-900">{getTerminalName({ guid: t.guid, descripcion: t.terminal?.descripcion })}</p>
              <FaChartLine className="w-4 h-4 text-emerald-600" />
            </div>
            <p className="text-xs text-gray-500 font-mono mb-1">GUID: {t.guid}</p>
            <p className="text-xs text-gray-500 mb-3">{t.terminal?.ubicacion || 'Sin ubicación'}</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="text-gray-500 flex items-center gap-1"><FaThermometerHalf className="w-3 h-3" /> Temp. aire</p>
                <p className="font-semibold text-gray-800">{Number(t.temperature_air || 0).toFixed(1)} °C</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="text-gray-500 flex items-center gap-1"><FaTint className="w-3 h-3" /> Hum. aire</p>
                <p className="font-semibold text-gray-800">{Number(t.humidity_air || 0).toFixed(1)} %</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="text-gray-500 flex items-center gap-1"><FaThermometerHalf className="w-3 h-3" /> Temp. 30cm</p>
                <p className="font-semibold text-gray-800">{Number(t.temperature_soil_30cm || 0).toFixed(1)} °C</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="text-gray-500 flex items-center gap-1"><FaTint className="w-3 h-3" /> Hum. 30cm</p>
                <p className="font-semibold text-gray-800">{Number(t.humidity_soil_30cm || 0).toFixed(1)} %</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="text-gray-500 flex items-center gap-1"><FaThermometerHalf className="w-3 h-3" /> Temp. 60cm</p>
                <p className="font-semibold text-gray-800">{Number(t.temperature_soil_60cm || 0).toFixed(1)} °C</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="text-gray-500 flex items-center gap-1"><FaTint className="w-3 h-3" /> Hum. 60cm</p>
                <p className="font-semibold text-gray-800">{Number(t.humidity_soil_60cm || 0).toFixed(1)} %</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="text-gray-500 flex items-center gap-1"><FaBolt className="w-3 h-3" /> Cond. 30cm</p>
                <p className="font-semibold text-gray-800">{Number(t.conductivity_soil_30cm || 0).toFixed(1)} µS/cm</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="text-gray-500 flex items-center gap-1"><FaBolt className="w-3 h-3" /> Cond. 60cm</p>
                <p className="font-semibold text-gray-800">{Number(t.conductivity_soil_60cm || 0).toFixed(1)} µS/cm</p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default GraphsOverviewPage;
